import { __, concat, pipe } from 'ramda'

export const toPixels = pipe(String, concat(__, 'px'))
